/* eslint-disable camelcase */
import { reportPageTypes } from 'modules/spaceLook/constants';

const MeetsAndBreakPeakUsage = ({ textData: { count_peek_reached }, pageType }) =>
  `The peak usage of the ${pageType === reportPageTypes.meetings ? 'meeting room(s)' : 'breakout space(s)'}
   was recorded on ${count_peek_reached} occasion(s).`;

export default MeetsAndBreakPeakUsage;
